import { render, staticRenderFns } from "./RegionSelectionSmall.vue?vue&type=template&id=ad7ccba8&scoped=true"
import script from "./RegionSelectionSmall.vue?vue&type=script&lang=js"
export * from "./RegionSelectionSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad7ccba8",
  null
  
)

export default component.exports